import { useEffect } from "react";
import { GA_MEASUREMENT_ID, GTM_ID } from "../../constant/site";

const appendScript = ({ id, src, content, async = true }) => {
  if (document.getElementById(id)) {
    return;
  }

  const script = document.createElement("script");
  script.id = id;
  if (src) {
    script.src = src;
    script.async = async;
  }
  if (content) {
    script.textContent = content;
  }
  document.head.appendChild(script);
};

function Analytics() {
  useEffect(() => {
    if (GTM_ID) {
      appendScript({
        id: "gtm-script",
        content: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${GTM_ID}');`,
      });
    }

    if (GA_MEASUREMENT_ID) {
      appendScript({
        id: "ga-script",
        src: `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`,
      });
      appendScript({
        id: "ga-init",
        content: `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${GA_MEASUREMENT_ID}');`,
      });
    }
  }, []);

  return null;
}

export default Analytics;